//  This file was automatically generated and should not be edited.

import {TaskReportFileMeta} from "@stores/taskLists/TaskReportModel";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string; }
    String: { input: string; output: string; }
    Boolean: { input: boolean; output: boolean; }
    Int: { input: number; output: number; }
    Float: { input: number; output: number; }
    AWSDateTime: { input: any; output: any; }
    AWSJSON: { input: any; output: any; }
    AWSTimestamp: { input: any; output: any; }
    DateTime: { input: any; output: any; }
    JSON: { input: Record<string, any>; output: Record<string, any>; }
};

export type AccessExplanation = {
    __typename?: 'AccessExplanation';
    bindingPath?: Maybe<Scalars['String']['output']>;
    hasAccess: Scalars['Boolean']['output'];
    reason: Scalars['String']['output'];
    roles?: Maybe<Array<Scalars['String']['output']>>;
};

export type AssignRoleToUserInput = {
    roleId: Scalars['ID']['input'];
    userId: Scalars['ID']['input'];
};

export type AssignRoleToUsersInput = {
    roleId: Scalars['ID']['input'];
    userIds: Array<Scalars['ID']['input']>;
    workspaceId: Scalars['ID']['input'];
};

export type AssignRoleToUsersResult = {
    __typename?: 'AssignRoleToUsersResult';
    created: Scalars['Int']['output'];
    deleted: Scalars['Int']['output'];
    success: Scalars['Boolean']['output'];
};

export type AssignRolesToUserInput = {
  roleIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type AuditLogConnection = {
    __typename?: 'AuditLogConnection';
    items: Array<AuditLogEntry>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type AuditLogEntry = {
    __typename?: 'AuditLogEntry';
    bindingId?: Maybe<Scalars['ID']['output']>;
    createdAt: Scalars['AWSDateTime']['output'];
    details?: Maybe<Scalars['AWSJSON']['output']>;
    entityId?: Maybe<Scalars['ID']['output']>;
    entityType?: Maybe<Scalars['String']['output']>;
    eventType: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    ownerId: Scalars['ID']['output'];
    roleId?: Maybe<Scalars['ID']['output']>;
    userId?: Maybe<Scalars['ID']['output']>;
};

export type Client = {
    __typename?: 'Client';
    createdAt: Scalars['AWSDateTime']['output'];
    created_at?: Maybe<Scalars['String']['output']>;
    customer_id?: Maybe<Scalars['String']['output']>;
    defaultWorkspaces?: Maybe<Scalars['String']['output']>;
    deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    id: Scalars['ID']['output'];
    inviteLink?: Maybe<Scalars['String']['output']>;
    meta: Scalars['AWSJSON']['output'];
    name: Scalars['String']['output'];
    ownerUserId: Scalars['ID']['output'];
    slug: string;
    subscription_details?: Maybe<Scalars['AWSJSON']['output']>;
    subscription_endsAt?: Maybe<Scalars['String']['output']>;
    subscription_plan?: Maybe<Scalars['String']['output']>;
    subscription_status?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['AWSDateTime']['output'];
    userRole?: Maybe<Scalars['String']['output']>;
    version: Scalars['Int']['output'];
};

export enum ClientAccessAction {
    ChangeRole = 'CHANGE_ROLE',
    DeleteUser = 'DELETE_USER'
}

export enum ClientAccessRole {
    Admin = 'ADMIN',
    Editor = 'EDITOR',
    Reader = 'READER'
}

export type ClientUpdateResult = Client | ConflictError;

export type ClientUsage = {
    __typename?: 'ClientUsage';
    aiUsageCount: Scalars['Int']['output'];
    clientId: Scalars['ID']['output'];
    itemsCount: Scalars['Int']['output'];
    quizzesCount: Scalars['Int']['output'];
};

export type ClientUser = {
    __typename?: 'ClientUser';
    avatarPath?: Maybe<Scalars['String']['output']>;
    closedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
    deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    email: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    isAdmin: Scalars['Boolean']['output'];
    isConfirmed?: Maybe<Scalars['Boolean']['output']>;
    isReadOnly: Scalars['Boolean']['output'];
    lastActive?: Maybe<Scalars['AWSDateTime']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    ownerId: Scalars['ID']['output'];
    roleUpdatedBy?: Maybe<Scalars['String']['output']>;
    roles: Scalars['AWSJSON']['output'];
    sub: Scalars['String']['output'];
    surname?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    version: Scalars['Int']['output'];
};

export type ClientUserUpdateResult = ClientUser | ConflictError;

export type ConflictError = {
    __typename?: 'ConflictError';
    actualVersion?: Maybe<Scalars['Int']['output']>;
    conflictType: ConflictType;
    currentState?: Maybe<Scalars['JSON']['output']>;
    entityId: Scalars['ID']['output'];
    entityType: Scalars['String']['output'];
    expectedVersion: Scalars['Int']['output'];
    metadata?: Maybe<Scalars['JSON']['output']>;
};

export enum ConflictType {
    EntityDeleted = 'ENTITY_DELETED',
    VersionMismatch = 'VERSION_MISMATCH'
}

export type CreateItemInput = {
    ackUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgement?: InputMaybe<Scalars['AWSJSON']['input']>;
    acknowledgementRequired?: InputMaybe<Scalars['Boolean']['input']>;
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    childIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    creator: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerId: Scalars['ID']['input'];
    parentIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    pinned?: InputMaybe<Scalars['Boolean']['input']>;
    pinnedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    readRoles?: InputMaybe<Scalars['AWSJSON']['input']>;
    statusRestoreParentIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    statusSourceLibraryId?: InputMaybe<Scalars['ID']['input']>;
    statusUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    trashed?: InputMaybe<Scalars['Boolean']['input']>;
    type: ItemType;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
    workspaceId: Scalars['ID']['input'];
    writeRoles?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreateNotificationInput = {
    channelAttempts?: InputMaybe<Scalars['AWSJSON']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    eventId?: InputMaybe<Scalars['ID']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    initiatorId?: InputMaybe<Scalars['ID']['input']>;
    meta: Scalars['AWSJSON']['input'];
    ownerId: Scalars['ID']['input'];
    status?: InputMaybe<Scalars['String']['input']>;
    type: Scalars['String']['input'];
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    userId: Scalars['ID']['input'];
};

export type CreateQuizAnswerInput = {
    answers?: InputMaybe<Scalars['AWSJSON']['input']>;
    attempt?: InputMaybe<Scalars['Int']['input']>;
    completedAt: Scalars['AWSDateTime']['input'];
    duration?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    ownerIdAndWsId: Scalars['String']['input'];
    quizAndUserId: Scalars['String']['input'];
    quizId: Scalars['ID']['input'];
    score?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['String']['input'];
};

export type CreateQuizInput = {
    creator: Scalars['String']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    latestEditor: Scalars['String']['input'];
    meta?: InputMaybe<Scalars['AWSJSON']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerIdAndWsId: Scalars['String']['input'];
    publication_state?: InputMaybe<Scalars['String']['input']>;
    questionsCount?: InputMaybe<Scalars['Int']['input']>;
    questionsOrder?: InputMaybe<Scalars['AWSJSON']['input']>;
    relatedPages?: InputMaybe<Scalars['String']['input']>;
    requiredPassPercentage?: InputMaybe<Scalars['Int']['input']>;
    statsPartId?: InputMaybe<Scalars['String']['input']>;
    statsPartValue?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreateQuizQuestionInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    options?: InputMaybe<Scalars['AWSJSON']['input']>;
    ownerIdAndWsId: Scalars['String']['input'];
    quizId: Scalars['ID']['input'];
    text: Scalars['String']['input'];
};

export type CreateQuizStatsInput = {
    answerId: Scalars['String']['input'];
    attempt?: InputMaybe<Scalars['Int']['input']>;
    completePercentage?: InputMaybe<Scalars['String']['input']>;
    completedAt: Scalars['AWSDateTime']['input'];
    id?: InputMaybe<Scalars['ID']['input']>;
    ownerIdAndWsId: Scalars['String']['input'];
    quizAndUserId: Scalars['ID']['input'];
    quizId: Scalars['ID']['input'];
    score?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['String']['input'];
    userIdAndStatus?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    displayName: Scalars['String']['input'];
    key: Scalars['String']['input'];
    workspaceId: Scalars['ID']['input'];
};

export type CreateTaskInput = {
    config?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    images?: InputMaybe<Scalars['JSON']['input']>;
    name: Scalars['String']['input'];
    relatedPage?: InputMaybe<Scalars['ID']['input']>;
    scheduleRule?: InputMaybe<Scalars['JSON']['input']>;
    taskListId?: InputMaybe<Scalars['ID']['input']>;
    taskListUnitId: Scalars['ID']['input'];
};

export type CreateTaskListUnitInput = {
    avatarPath?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    logicalDayShift: Scalars['Int']['input'];
    name: Scalars['String']['input'];
    taskLists?: InputMaybe<Scalars['JSON']['input']>;
    taskListsOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
    timezone: Scalars['String']['input'];
    workspaceId: Scalars['ID']['input'];
};

export type CreateTaskReportInput = {
    comment?: InputMaybe<Scalars['String']['input']>;
    commentImages?: InputMaybe<Scalars['JSON']['input']>;
    completedAt: Scalars['DateTime']['input'];
    completedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
    images?: InputMaybe<Scalars['JSON']['input']>;
    shiftHours: Scalars['Int']['input'];
    status: TaskReportStatus;
    taskId: Scalars['ID']['input'];
    taskListUnitId: Scalars['ID']['input'];
    timezone: Scalars['String']['input'];
};

export type CreateWorkspaceInput = {
    archivedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    avatarPath?: InputMaybe<Scalars['String']['input']>;
    childIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerId: Scalars['ID']['input'];
    pinnedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    trashedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWorkspaceUserInput = {
    createdBy?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    ownerId: Scalars['ID']['input'];
    role: Scalars['String']['input'];
    updatedBy?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['ID']['input'];
    version?: InputMaybe<Scalars['Int']['input']>;
    workspaceId: Scalars['ID']['input'];
};

export type DeleteItemInput = {
    id: Scalars['ID']['input'];
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteQuizAnswerInput = {
    id: Scalars['ID']['input'];
};

export type DeleteQuizInput = {
    id: Scalars['ID']['input'];
};

export type DeleteQuizQuestionInput = {
    id: Scalars['ID']['input'];
};

export type DeleteQuizStatsInput = {
    answerId?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    ownerIdAndWsId: Scalars['String']['input'];
    quizAndUserId: Scalars['ID']['input'];
};

export type DeleteRoleInput = {
    id: Scalars['ID']['input'];
};

export type DeleteTaskInput = {
    id: Scalars['ID']['input'];
};

export type DeleteTaskListInput = {
    taskListId: Scalars['ID']['input'];
    taskListUnitId: Scalars['ID']['input'];
    version: Scalars['Int']['input'];
};

export type DeleteTaskListUnitInput = {
    id: Scalars['ID']['input'];
};

export type DeleteTaskReportInput = {
    id: Scalars['ID']['input'];
};

export type DeleteWorkspaceInput = {
    id: Scalars['ID']['input'];
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteWorkspaceUserInput = {
    id: Scalars['ID']['input'];
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type DuplicateClusterInput = {
    sourceId: Scalars['ID']['input'];
    parentId?: InputMaybe<Scalars['ID']['input']>;
    index?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteItemForeverInput = {
    id: Scalars['ID']['input'];
    force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DuplicateTaskListInput = {
    index?: InputMaybe<Scalars['Int']['input']>;
    targetTaskListUnitId?: InputMaybe<Scalars['ID']['input']>;
    taskListId: Scalars['ID']['input'];
    taskListUnitId: Scalars['ID']['input'];
};

export type DuplicateTaskListUnitInput = {
    id: Scalars['ID']['input'];
};

export type EntitySelectionInput = {
    entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    includeFuture?: InputMaybe<Scalars['Boolean']['input']>;
    type: Scalars['String']['input'];
    workspaceId: Scalars['ID']['input'];
};

export type ExplainAccessInput = {
    entityId: Scalars['ID']['input'];
    entityType: Scalars['String']['input'];
    userId: Scalars['ID']['input'];
};

export type GetLatestQuizAnswerInput = {
    quizId: Scalars['ID']['input'];
};

export type GetQuizStatisticsInput = {
    completedAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
    minScore?: InputMaybe<Scalars['Int']['input']>;
    quizId: Scalars['ID']['input'];
    status?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserQuizProgressInput = {
    workspaceId: Scalars['ID']['input'];
};

export type GrantLibraryAccessInput = {
    grantAll?: InputMaybe<Scalars['Boolean']['input']>;
    libraryId?: InputMaybe<Scalars['ID']['input']>;
    roleId: Scalars['ID']['input'];
    workspaceId: Scalars['ID']['input'];
};

export type GrantQuizAccessInput = {
    grantAll?: InputMaybe<Scalars['Boolean']['input']>;
    quizId?: InputMaybe<Scalars['ID']['input']>;
    roleId: Scalars['ID']['input'];
    workspaceId: Scalars['ID']['input'];
};

export type GrantTaskListAccessInput = {
    grantAll?: InputMaybe<Scalars['Boolean']['input']>;
    roleId: Scalars['ID']['input'];
    taskListId?: InputMaybe<Scalars['ID']['input']>;
    taskListUnitId?: InputMaybe<Scalars['ID']['input']>;
    workspaceId: Scalars['ID']['input'];
};

export type GrantWorkspaceAccessInput = {
    grantAll?: InputMaybe<Scalars['Boolean']['input']>;
    roleId: Scalars['ID']['input'];
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type Item = {
    __typename?: 'Item';
    ackUpdatedBy?: Maybe<Scalars['String']['output']>;
    acknowledgement?: Maybe<Scalars['AWSJSON']['output']>;
    acknowledgementRequired?: Maybe<Scalars['Boolean']['output']>;
    archived: Scalars['Boolean']['output'];
    childIds: Scalars['AWSJSON']['output'];
    createdAt: Scalars['AWSDateTime']['output'];
    creator: Scalars['String']['output'];
    deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    ownerId: Scalars['ID']['output'];
    parentIds: Scalars['AWSJSON']['output'];
    pinned?: Maybe<Scalars['Boolean']['output']>;
    pinnedIds?: Maybe<Scalars['AWSJSON']['output']>;
    readRoles: Scalars['AWSJSON']['output'];
    statusRestoreParentIds?: Maybe<Scalars['AWSJSON']['output']>;
    statusSourceLibraryId?: Maybe<Scalars['ID']['output']>;
    statusUpdatedBy?: Maybe<Scalars['String']['output']>;
    trashed: Scalars['Boolean']['output'];
    type: ItemType;
    updatedAt: Scalars['AWSDateTime']['output'];
    updatedBy?: Maybe<Scalars['String']['output']>;
    version: Scalars['Int']['output'];
    workspaceId: Scalars['ID']['output'];
    writeRoles: Scalars['AWSJSON']['output'];
};

export enum ItemType {
    CLUSTER = 'CLUSTER',
    LEAF = 'LEAF',
    LIBRARY = 'LIBRARY'
}

export type ItemUpdateResult = ConflictError | Item;

export type ManageClientUserAccessInput = {
    action: ClientAccessAction;
    targetRole?: InputMaybe<ClientAccessRole>;
    targetSub: Scalars['ID']['input'];
};

export type ManageClientUserAccessResult = {
    __typename?: 'ManageClientUserAccessResult';
    message?: Maybe<Scalars['String']['output']>;
    success: Scalars['Boolean']['output'];
};

export enum ModelAttributeTypes {
    Null = '_null',
    Binary = 'binary',
    BinarySet = 'binarySet',
    Bool = 'bool',
    List = 'list',
    Map = 'map',
    Number = 'number',
    NumberSet = 'numberSet',
    String = 'string',
    StringSet = 'stringSet'
}

export type ModelBooleanInput = {
    attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
    attributeType?: InputMaybe<ModelAttributeTypes>;
    eq?: InputMaybe<Scalars['Boolean']['input']>;
    ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelClientConnection = {
    __typename?: 'ModelClientConnection';
    items: Array<Maybe<Client>>;
    nextToken?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ModelClientFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelClientFilterInput>>>;
    createdAt?: InputMaybe<ModelStringInput>;
    created_at?: InputMaybe<ModelStringInput>;
    customer_id?: InputMaybe<ModelStringInput>;
    defaultWorkspaces?: InputMaybe<ModelStringInput>;
    id?: InputMaybe<ModelIdInput>;
    inviteLink?: InputMaybe<ModelStringInput>;
    meta?: InputMaybe<ModelStringInput>;
    name?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelClientFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelClientFilterInput>>>;
    ownerUserId?: InputMaybe<ModelIdInput>;
    slug?: InputMaybe<ModelStringInput>;
    subscription_details?: InputMaybe<ModelStringInput>;
    subscription_endsAt?: InputMaybe<ModelStringInput>;
    subscription_plan?: InputMaybe<ModelStringInput>;
    subscription_status?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
    userRole?: InputMaybe<ModelStringInput>;
};

export type ModelClientUserConnection = {
    __typename?: 'ModelClientUserConnection';
    items: Array<Maybe<ClientUser>>;
    nextToken?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ModelClientUserFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelClientUserFilterInput>>>;
    avatarPath?: InputMaybe<ModelStringInput>;
    closedAt?: InputMaybe<ModelStringInput>;
    createdAt?: InputMaybe<ModelStringInput>;
    email?: InputMaybe<ModelStringInput>;
    id?: InputMaybe<ModelIdInput>;
    isAdmin?: InputMaybe<ModelBooleanInput>;
    isConfirmed?: InputMaybe<ModelBooleanInput>;
    isReadOnly?: InputMaybe<ModelBooleanInput>;
    lastActive?: InputMaybe<ModelStringInput>;
    name?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelClientUserFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelClientUserFilterInput>>>;
    ownerId?: InputMaybe<ModelIdInput>;
    roleUpdatedBy?: InputMaybe<ModelStringInput>;
    roles?: InputMaybe<ModelStringInput>;
    sub?: InputMaybe<ModelStringInput>;
    surname?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelIdInput = {
    attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
    attributeType?: InputMaybe<ModelAttributeTypes>;
    beginsWith?: InputMaybe<Scalars['ID']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    contains?: InputMaybe<Scalars['ID']['input']>;
    eq?: InputMaybe<Scalars['ID']['input']>;
    ge?: InputMaybe<Scalars['ID']['input']>;
    gt?: InputMaybe<Scalars['ID']['input']>;
    le?: InputMaybe<Scalars['ID']['input']>;
    lt?: InputMaybe<Scalars['ID']['input']>;
    ne?: InputMaybe<Scalars['ID']['input']>;
    notContains?: InputMaybe<Scalars['ID']['input']>;
    size?: InputMaybe<ModelSizeInput>;
};

export type ModelIdKeyConditionInput = {
    beginsWith?: InputMaybe<Scalars['ID']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    eq?: InputMaybe<Scalars['ID']['input']>;
    ge?: InputMaybe<Scalars['ID']['input']>;
    gt?: InputMaybe<Scalars['ID']['input']>;
    le?: InputMaybe<Scalars['ID']['input']>;
    lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelIntInput = {
    attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
    attributeType?: InputMaybe<ModelAttributeTypes>;
    between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    eq?: InputMaybe<Scalars['Int']['input']>;
    ge?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    le?: InputMaybe<Scalars['Int']['input']>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelItemConnection = {
    __typename?: 'ModelItemConnection';
    items: Array<Maybe<Item>>;
    nextToken?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ModelItemFilterInput = {
    ackUpdatedBy?: InputMaybe<ModelStringInput>;
    acknowledgementRequired?: InputMaybe<ModelBooleanInput>;
    and?: InputMaybe<Array<InputMaybe<ModelItemFilterInput>>>;
    archived?: InputMaybe<ModelBooleanInput>;
    createdAt?: InputMaybe<ModelStringInput>;
    creator?: InputMaybe<ModelStringInput>;
    id?: InputMaybe<ModelIdInput>;
    name?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelItemFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelItemFilterInput>>>;
    ownerId?: InputMaybe<ModelStringInput>;
    pinned?: InputMaybe<ModelBooleanInput>;
    statusRestoreParentIds?: InputMaybe<ModelStringInput>;
    statusSourceLibraryId?: InputMaybe<ModelIdInput>;
    statusUpdatedBy?: InputMaybe<ModelStringInput>;
    trashed?: InputMaybe<ModelBooleanInput>;
    type?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
    workspaceId?: InputMaybe<ModelIdInput>;
};

export type ModelNotificationByClientCompositeKeyConditionInput = {
    beginsWith?: InputMaybe<ModelNotificationByClientCompositeKeyInput>;
    between?: InputMaybe<Array<InputMaybe<ModelNotificationByClientCompositeKeyInput>>>;
    eq?: InputMaybe<ModelNotificationByClientCompositeKeyInput>;
    ge?: InputMaybe<ModelNotificationByClientCompositeKeyInput>;
    gt?: InputMaybe<ModelNotificationByClientCompositeKeyInput>;
    le?: InputMaybe<ModelNotificationByClientCompositeKeyInput>;
    lt?: InputMaybe<ModelNotificationByClientCompositeKeyInput>;
};

export type ModelNotificationByClientCompositeKeyInput = {
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelNotificationConnection = {
    __typename?: 'ModelNotificationConnection';
    items: Array<Maybe<Notification>>;
    nextToken?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ModelNotificationFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelNotificationFilterInput>>>;
    channelAttempts?: InputMaybe<ModelStringInput>;
    createdAt?: InputMaybe<ModelStringInput>;
    eventId?: InputMaybe<ModelIdInput>;
    initiatorId?: InputMaybe<ModelIdInput>;
    meta?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelNotificationFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelNotificationFilterInput>>>;
    ownerId?: InputMaybe<ModelIdInput>;
    status?: InputMaybe<ModelStringInput>;
    type?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
    userId?: InputMaybe<ModelIdInput>;
};

export type ModelQuizAnswerConditionInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizAnswerConditionInput>>>;
    answers?: InputMaybe<ModelStringInput>;
    attempt?: InputMaybe<ModelIntInput>;
    completedAt?: InputMaybe<ModelStringInput>;
    duration?: InputMaybe<ModelIntInput>;
    not?: InputMaybe<ModelQuizAnswerConditionInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizAnswerConditionInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    quizAndUserId?: InputMaybe<ModelStringInput>;
    quizId?: InputMaybe<ModelIdInput>;
    score?: InputMaybe<ModelStringInput>;
    status?: InputMaybe<ModelStringInput>;
    userId?: InputMaybe<ModelStringInput>;
};

export type ModelQuizAnswerConnection = {
    __typename?: 'ModelQuizAnswerConnection';
    items: Array<Maybe<QuizAnswer>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelQuizAnswerFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizAnswerFilterInput>>>;
    answers?: InputMaybe<ModelStringInput>;
    attempt?: InputMaybe<ModelIntInput>;
    completedAt?: InputMaybe<ModelStringInput>;
    duration?: InputMaybe<ModelIntInput>;
    id?: InputMaybe<ModelIdInput>;
    not?: InputMaybe<ModelQuizAnswerFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizAnswerFilterInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    quizAndUserId?: InputMaybe<ModelStringInput>;
    quizId?: InputMaybe<ModelIdInput>;
    score?: InputMaybe<ModelStringInput>;
    status?: InputMaybe<ModelStringInput>;
    userId?: InputMaybe<ModelStringInput>;
};

export type ModelQuizConditionInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizConditionInput>>>;
    createdAt?: InputMaybe<ModelStringInput>;
    creator?: InputMaybe<ModelStringInput>;
    latestEditor?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelQuizConditionInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizConditionInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    publication_state?: InputMaybe<ModelStringInput>;
    questionsCount?: InputMaybe<ModelIntInput>;
    questionsOrder?: InputMaybe<ModelStringInput>;
    relatedPages?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
    version?: InputMaybe<ModelIntInput>;
};

export type ModelQuizConnection = {
    __typename?: 'ModelQuizConnection';
    items: Array<Maybe<Quiz>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelQuizFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizFilterInput>>>;
    createdAt?: InputMaybe<ModelStringInput>;
    creator?: InputMaybe<ModelStringInput>;
    description?: InputMaybe<ModelStringInput>;
    id?: InputMaybe<ModelIdInput>;
    latestEditor?: InputMaybe<ModelStringInput>;
    name?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelQuizFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizFilterInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    publication_state?: InputMaybe<ModelStringInput>;
    questionsCount?: InputMaybe<ModelIntInput>;
    questionsOrder?: InputMaybe<ModelStringInput>;
    relatedPages?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
    version?: InputMaybe<ModelIntInput>;
};

export type ModelQuizQuestionConditionInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizQuestionConditionInput>>>;
    not?: InputMaybe<ModelQuizQuestionConditionInput>;
    options?: InputMaybe<ModelStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizQuestionConditionInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    quizId?: InputMaybe<ModelIdInput>;
    text?: InputMaybe<ModelStringInput>;
};

export type ModelQuizQuestionConnection = {
    __typename?: 'ModelQuizQuestionConnection';
    items: Array<Maybe<QuizQuestion>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelQuizQuestionFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizQuestionFilterInput>>>;
    id?: InputMaybe<ModelIdInput>;
    not?: InputMaybe<ModelQuizQuestionFilterInput>;
    options?: InputMaybe<ModelStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizQuestionFilterInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    quizId?: InputMaybe<ModelIdInput>;
    text?: InputMaybe<ModelStringInput>;
};

export type ModelQuizStatsConditionInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizStatsConditionInput>>>;
    answerId?: InputMaybe<ModelStringInput>;
    attempt?: InputMaybe<ModelIntInput>;
    completePercentage?: InputMaybe<ModelStringInput>;
    completedAt?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelQuizStatsConditionInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizStatsConditionInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    quizAndUserId?: InputMaybe<ModelIdInput>;
    quizId?: InputMaybe<ModelIdInput>;
    score?: InputMaybe<ModelStringInput>;
    status?: InputMaybe<ModelStringInput>;
    userId?: InputMaybe<ModelStringInput>;
    userIdAndStatus?: InputMaybe<ModelStringInput>;
};

export type ModelQuizStatsConnection = {
    __typename?: 'ModelQuizStatsConnection';
    items: Array<Maybe<QuizStats>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelQuizStatsFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelQuizStatsFilterInput>>>;
    answerId?: InputMaybe<ModelStringInput>;
    attempt?: InputMaybe<ModelIntInput>;
    completePercentage?: InputMaybe<ModelStringInput>;
    completedAt?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelQuizStatsFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelQuizStatsFilterInput>>>;
    ownerIdAndWsId?: InputMaybe<ModelStringInput>;
    quizAndUserId?: InputMaybe<ModelIdInput>;
    quizId?: InputMaybe<ModelIdInput>;
    score?: InputMaybe<ModelStringInput>;
    status?: InputMaybe<ModelStringInput>;
    userId?: InputMaybe<ModelStringInput>;
    userIdAndStatus?: InputMaybe<ModelStringInput>;
};

export type ModelSizeInput = {
    between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    eq?: InputMaybe<Scalars['Int']['input']>;
    ge?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    le?: InputMaybe<Scalars['Int']['input']>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    ne?: InputMaybe<Scalars['Int']['input']>;
};

export enum ModelSortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}

export type ModelStringInput = {
    attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
    attributeType?: InputMaybe<ModelAttributeTypes>;
    beginsWith?: InputMaybe<Scalars['String']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contains?: InputMaybe<Scalars['String']['input']>;
    eq?: InputMaybe<Scalars['String']['input']>;
    ge?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    le?: InputMaybe<Scalars['String']['input']>;
    lt?: InputMaybe<Scalars['String']['input']>;
    ne?: InputMaybe<Scalars['String']['input']>;
    notContains?: InputMaybe<Scalars['String']['input']>;
    size?: InputMaybe<ModelSizeInput>;
};

export type ModelStringKeyConditionInput = {
    beginsWith?: InputMaybe<Scalars['String']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    eq?: InputMaybe<Scalars['String']['input']>;
    ge?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    le?: InputMaybe<Scalars['String']['input']>;
    lt?: InputMaybe<Scalars['String']['input']>;
};

export type ModelSubscriptionBooleanInput = {
    eq?: InputMaybe<Scalars['Boolean']['input']>;
    ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelSubscriptionClientFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionClientFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    created_at?: InputMaybe<ModelSubscriptionStringInput>;
    customer_id?: InputMaybe<ModelSubscriptionStringInput>;
    defaultWorkspaces?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    inviteLink?: InputMaybe<ModelSubscriptionStringInput>;
    meta?: InputMaybe<ModelSubscriptionStringInput>;
    name?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionClientFilterInput>>>;
    ownerUserId?: InputMaybe<ModelSubscriptionIdInput>;
    slug?: InputMaybe<ModelSubscriptionStringInput>;
    subscription_details?: InputMaybe<ModelSubscriptionStringInput>;
    subscription_endsAt?: InputMaybe<ModelSubscriptionStringInput>;
    subscription_plan?: InputMaybe<ModelSubscriptionStringInput>;
    subscription_status?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
    userRole?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionClientUserFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionClientUserFilterInput>>>;
    avatarPath?: InputMaybe<ModelSubscriptionStringInput>;
    closedAt?: InputMaybe<ModelSubscriptionStringInput>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    email?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    isAdmin?: InputMaybe<ModelSubscriptionBooleanInput>;
    isConfirmed?: InputMaybe<ModelSubscriptionBooleanInput>;
    isReadOnly?: InputMaybe<ModelSubscriptionBooleanInput>;
    lastActive?: InputMaybe<ModelSubscriptionStringInput>;
    name?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionClientUserFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    roleUpdatedBy?: InputMaybe<ModelSubscriptionStringInput>;
    roles?: InputMaybe<ModelSubscriptionStringInput>;
    sub?: InputMaybe<ModelSubscriptionStringInput>;
    surname?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionFloatInput = {
    between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    eq?: InputMaybe<Scalars['Float']['input']>;
    ge?: InputMaybe<Scalars['Float']['input']>;
    gt?: InputMaybe<Scalars['Float']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
    le?: InputMaybe<Scalars['Float']['input']>;
    lt?: InputMaybe<Scalars['Float']['input']>;
    ne?: InputMaybe<Scalars['Float']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type ModelSubscriptionIdInput = {
    beginsWith?: InputMaybe<Scalars['ID']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    contains?: InputMaybe<Scalars['ID']['input']>;
    eq?: InputMaybe<Scalars['ID']['input']>;
    ge?: InputMaybe<Scalars['ID']['input']>;
    gt?: InputMaybe<Scalars['ID']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    le?: InputMaybe<Scalars['ID']['input']>;
    lt?: InputMaybe<Scalars['ID']['input']>;
    ne?: InputMaybe<Scalars['ID']['input']>;
    notContains?: InputMaybe<Scalars['ID']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ModelSubscriptionIntInput = {
    between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    eq?: InputMaybe<Scalars['Int']['input']>;
    ge?: InputMaybe<Scalars['Int']['input']>;
    gt?: InputMaybe<Scalars['Int']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    le?: InputMaybe<Scalars['Int']['input']>;
    lt?: InputMaybe<Scalars['Int']['input']>;
    ne?: InputMaybe<Scalars['Int']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ModelSubscriptionItemFilterInput = {
    ackUpdatedBy?: InputMaybe<ModelSubscriptionStringInput>;
    acknowledgement?: InputMaybe<ModelSubscriptionStringInput>;
    acknowledgementRequired?: InputMaybe<ModelSubscriptionBooleanInput>;
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionItemFilterInput>>>;
    archived?: InputMaybe<ModelSubscriptionBooleanInput>;
    childIds?: InputMaybe<ModelSubscriptionStringInput>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    creator?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    name?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionItemFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionStringInput>;
    parentIds?: InputMaybe<ModelSubscriptionStringInput>;
    pinned?: InputMaybe<ModelSubscriptionBooleanInput>;
    readRoles?: InputMaybe<ModelSubscriptionStringInput>;
    statusRestoreParentIds?: InputMaybe<ModelSubscriptionStringInput>;
    statusSourceLibraryId?: InputMaybe<ModelSubscriptionIdInput>;
    statusUpdatedBy?: InputMaybe<ModelSubscriptionStringInput>;
    trashed?: InputMaybe<ModelSubscriptionBooleanInput>;
    type?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
    workspaceId?: InputMaybe<ModelSubscriptionIdInput>;
    writeRoles?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionNotificationFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionNotificationFilterInput>>>;
    channelAttempts?: InputMaybe<ModelSubscriptionStringInput>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    eventId?: InputMaybe<ModelSubscriptionIdInput>;
    initiatorId?: InputMaybe<ModelSubscriptionIdInput>;
    meta?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionNotificationFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    status?: InputMaybe<ModelSubscriptionStringInput>;
    type?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
    userId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionQuizAnswerFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizAnswerFilterInput>>>;
    answers?: InputMaybe<ModelSubscriptionStringInput>;
    attempt?: InputMaybe<ModelSubscriptionIntInput>;
    completedAt?: InputMaybe<ModelSubscriptionStringInput>;
    duration?: InputMaybe<ModelSubscriptionIntInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizAnswerFilterInput>>>;
    quizAndUserId?: InputMaybe<ModelSubscriptionStringInput>;
    quizId?: InputMaybe<ModelSubscriptionIdInput>;
    score?: InputMaybe<ModelSubscriptionStringInput>;
    status?: InputMaybe<ModelSubscriptionStringInput>;
    userId?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionQuizFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    creator?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    latestEditor?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizFilterInput>>>;
    publication_state?: InputMaybe<ModelSubscriptionStringInput>;
    questionsCount?: InputMaybe<ModelSubscriptionIntInput>;
    questionsOrder?: InputMaybe<ModelSubscriptionStringInput>;
    relatedPages?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionQuizQuestionFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizQuestionFilterInput>>>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    options?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizQuestionFilterInput>>>;
    quizId?: InputMaybe<ModelSubscriptionIdInput>;
    text?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionQuizStatsFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizStatsFilterInput>>>;
    answerId?: InputMaybe<ModelSubscriptionStringInput>;
    attempt?: InputMaybe<ModelSubscriptionIntInput>;
    completePercentage?: InputMaybe<ModelSubscriptionStringInput>;
    completedAt?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionQuizStatsFilterInput>>>;
    quizAndUserId?: InputMaybe<ModelSubscriptionIdInput>;
    quizId?: InputMaybe<ModelSubscriptionIdInput>;
    score?: InputMaybe<ModelSubscriptionStringInput>;
    userId?: InputMaybe<ModelSubscriptionStringInput>;
    userIdAndStatus?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionRoleBindingFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionRoleBindingFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    objectId?: InputMaybe<ModelSubscriptionIdInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionRoleBindingFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    roleId?: InputMaybe<ModelSubscriptionIdInput>;
    subjectId?: InputMaybe<ModelSubscriptionIdInput>;
    workspaceId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionRoleFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionRoleFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    description?: InputMaybe<ModelSubscriptionStringInput>;
    displayName?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    key?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionRoleFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionRolePermissionFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionRolePermissionFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    objectId?: InputMaybe<ModelSubscriptionIdInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionRolePermissionFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    roleId?: InputMaybe<ModelSubscriptionIdInput>;
    workspaceId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionStringInput = {
    beginsWith?: InputMaybe<Scalars['String']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contains?: InputMaybe<Scalars['String']['input']>;
    eq?: InputMaybe<Scalars['String']['input']>;
    ge?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    le?: InputMaybe<Scalars['String']['input']>;
    lt?: InputMaybe<Scalars['String']['input']>;
    ne?: InputMaybe<Scalars['String']['input']>;
    notContains?: InputMaybe<Scalars['String']['input']>;
    notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModelSubscriptionUserRoleFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionUserRoleFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionUserRoleFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    roleId?: InputMaybe<ModelSubscriptionIdInput>;
    userId?: InputMaybe<ModelSubscriptionIdInput>;
    workspaceId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionWorkspaceFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionWorkspaceFilterInput>>>;
    archivedIds?: InputMaybe<ModelSubscriptionStringInput>;
    avatarPath?: InputMaybe<ModelSubscriptionStringInput>;
    childIds?: InputMaybe<ModelSubscriptionStringInput>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    name?: InputMaybe<ModelSubscriptionStringInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionWorkspaceFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionStringInput>;
    pinnedIds?: InputMaybe<ModelSubscriptionStringInput>;
    slug?: InputMaybe<ModelSubscriptionStringInput>;
    trashedIds?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionWorkspaceUserFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelSubscriptionWorkspaceUserFilterInput>>>;
    createdAt?: InputMaybe<ModelSubscriptionStringInput>;
    createdBy?: InputMaybe<ModelSubscriptionStringInput>;
    id?: InputMaybe<ModelSubscriptionIdInput>;
    or?: InputMaybe<Array<InputMaybe<ModelSubscriptionWorkspaceUserFilterInput>>>;
    ownerId?: InputMaybe<ModelSubscriptionIdInput>;
    role?: InputMaybe<ModelSubscriptionStringInput>;
    updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
    updatedBy?: InputMaybe<ModelSubscriptionStringInput>;
    userId?: InputMaybe<ModelSubscriptionIdInput>;
    workspaceId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelWorkspaceConnection = {
    __typename?: 'ModelWorkspaceConnection';
    items: Array<Maybe<Workspace>>;
    nextToken?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ModelWorkspaceFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelWorkspaceFilterInput>>>;
    archivedIds?: InputMaybe<ModelStringInput>;
    avatarPath?: InputMaybe<ModelStringInput>;
    childIds?: InputMaybe<ModelStringInput>;
    createdAt?: InputMaybe<ModelStringInput>;
    id?: InputMaybe<ModelIdInput>;
    name?: InputMaybe<ModelStringInput>;
    not?: InputMaybe<ModelWorkspaceFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelWorkspaceFilterInput>>>;
    ownerId?: InputMaybe<ModelStringInput>;
    pinnedIds?: InputMaybe<ModelStringInput>;
    slug?: InputMaybe<ModelStringInput>;
    trashedIds?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelWorkspaceUserByWorkspaceCompositeKeyConditionInput = {
    beginsWith?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>;
    between?: InputMaybe<Array<InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>>>;
    eq?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>;
    ge?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>;
    gt?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>;
    le?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>;
    lt?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyInput>;
};

export type ModelWorkspaceUserByWorkspaceCompositeKeyInput = {
    userId?: InputMaybe<Scalars['ID']['input']>;
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelWorkspaceUserConnection = {
    __typename?: 'ModelWorkspaceUserConnection';
    items: Array<Maybe<WorkspaceUser>>;
    nextToken?: Maybe<Scalars['String']['output']>;
    startedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ModelWorkspaceUserFilterInput = {
    and?: InputMaybe<Array<InputMaybe<ModelWorkspaceUserFilterInput>>>;
    createdAt?: InputMaybe<ModelStringInput>;
    createdBy?: InputMaybe<ModelStringInput>;
    id?: InputMaybe<ModelIdInput>;
    not?: InputMaybe<ModelWorkspaceUserFilterInput>;
    or?: InputMaybe<Array<InputMaybe<ModelWorkspaceUserFilterInput>>>;
    ownerId?: InputMaybe<ModelIdInput>;
    role?: InputMaybe<ModelStringInput>;
    updatedAt?: InputMaybe<ModelStringInput>;
    updatedBy?: InputMaybe<ModelStringInput>;
    userId?: InputMaybe<ModelIdInput>;
    workspaceId?: InputMaybe<ModelIdInput>;
};

export type Mutation = {
    __typename?: 'Mutation';
    assignRoleToUser: RoleBinding;
    assignRoleToUsers: AssignRoleToUsersResult;
    createItem: Item;
    createNotification: Notification;
    createQuiz?: Maybe<Quiz>;
    createQuizAnswer?: Maybe<QuizAnswer>;
    createQuizQuestion?: Maybe<QuizQuestion>;
    createQuizStats?: Maybe<QuizStats>;
    createRole: Role;
    createTask: Task;
    createTaskListUnit: TaskListUnit;
    createTaskReport: TaskReport;
    createWorkspace: Workspace;
    createWorkspaceUser: WorkspaceUser;
    deleteItem: Item;
    deleteQuiz?: Maybe<Quiz>;
    deleteQuizAnswer?: Maybe<QuizAnswer>;
    deleteQuizQuestion?: Maybe<QuizQuestion>;
    deleteQuizStats?: Maybe<QuizStats>;
    deleteRole: Role;
    deleteTask: Task;
    deleteTaskList: TaskListUnit;
    deleteTaskListUnit: TaskListUnit;
    deleteTaskReport: TaskReport;
    deleteWorkspace: Workspace;
    deleteWorkspaceUser: WorkspaceUser;
    deleteItemForever: Array<Item>;
    duplicateCluster: Item;
    duplicateTaskList: TaskListUnit;
    duplicateTaskListUnit: TaskListUnit;
    grantLibraryAccess: RoleBinding;
    grantQuizAccess: RoleBinding;
    grantTaskListAccess: RoleBinding;
    grantWorkspaceAccess: RoleBinding;
    manageClientUserAccess: ManageClientUserAccessResult;
    registerPushSubscription: PushSubscriptionResult;
    removeRoleFromUser: RoleBinding;
    restoreTask: Task;
    restoreTaskList: TaskListUnit;
    restoreTaskListUnit: TaskListUnit;
    revokeAccess: RoleBinding;
    saveRole: Role;
    unregisterPushSubscription: PushSubscriptionResult;
    updateClient: ClientUpdateResult;
    updateClientUser: ClientUserUpdateResult;
    updateItem: ItemUpdateResult;
    updateNotification: NotificationUpdateResult;
    updateQuiz?: Maybe<QuizUpdateResult>;
    updateQuizAnswer?: Maybe<QuizAnswerUpdateResult>;
    updateQuizQuestion?: Maybe<QuizQuestionUpdateResult>;
    updateQuizStats?: Maybe<QuizStatsUpdateResult>;
    updateRole: Role;
    updateTask: TaskUpdateResult;
    updateTaskListUnit: TaskListUnitUpdateResult;
    updateTaskReport: TaskReportUpdateResult;
    updateWorkspace: WorkspaceUpdateResult;
    updateWorkspaceUser: WorkspaceUser;
};


export type MutationAssignRoleToUserArgs = {
    input: AssignRoleToUserInput;
};


export type MutationAssignRoleToUsersArgs = {
    input: AssignRoleToUsersInput;
};


export type MutationCreateItemArgs = {
    input: CreateItemInput;
};


export type MutationCreateNotificationArgs = {
    input: CreateNotificationInput;
};


export type MutationCreateQuizArgs = {
    condition?: InputMaybe<ModelQuizConditionInput>;
    input: CreateQuizInput;
};


export type MutationCreateQuizAnswerArgs = {
    condition?: InputMaybe<ModelQuizAnswerConditionInput>;
    input: CreateQuizAnswerInput;
};


export type MutationCreateQuizQuestionArgs = {
    condition?: InputMaybe<ModelQuizQuestionConditionInput>;
    input: CreateQuizQuestionInput;
};


export type MutationCreateQuizStatsArgs = {
    condition?: InputMaybe<ModelQuizStatsConditionInput>;
    input: CreateQuizStatsInput;
};


export type MutationCreateRoleArgs = {
    input: CreateRoleInput;
};


export type MutationCreateTaskArgs = {
    input: CreateTaskInput;
};


export type MutationCreateTaskListUnitArgs = {
    input: CreateTaskListUnitInput;
};


export type MutationCreateTaskReportArgs = {
    input: CreateTaskReportInput;
};


export type MutationCreateWorkspaceArgs = {
    input: CreateWorkspaceInput;
};


export type MutationCreateWorkspaceUserArgs = {
    input: CreateWorkspaceUserInput;
};


export type MutationDeleteItemArgs = {
    input: DeleteItemInput;
};


export type MutationDeleteQuizArgs = {
    condition?: InputMaybe<ModelQuizConditionInput>;
    input: DeleteQuizInput;
};


export type MutationDeleteQuizAnswerArgs = {
    condition?: InputMaybe<ModelQuizAnswerConditionInput>;
    input: DeleteQuizAnswerInput;
};


export type MutationDeleteQuizQuestionArgs = {
    condition?: InputMaybe<ModelQuizQuestionConditionInput>;
    input: DeleteQuizQuestionInput;
};


export type MutationDeleteQuizStatsArgs = {
    condition?: InputMaybe<ModelQuizStatsConditionInput>;
    input: DeleteQuizStatsInput;
};


export type MutationDeleteRoleArgs = {
    input: DeleteRoleInput;
};


export type MutationDeleteTaskArgs = {
    input: DeleteTaskInput;
};


export type MutationDeleteTaskListArgs = {
    input: DeleteTaskListInput;
};


export type MutationDeleteTaskListUnitArgs = {
    input: DeleteTaskListUnitInput;
};


export type MutationDeleteTaskReportArgs = {
    input: DeleteTaskReportInput;
};


export type MutationDeleteWorkspaceArgs = {
    input: DeleteWorkspaceInput;
};


export type MutationDeleteWorkspaceUserArgs = {
    input: DeleteWorkspaceUserInput;
};


export type MutationDuplicateClusterArgs = {
    input: DuplicateClusterInput;
};


export type MutationDeleteItemForeverArgs = {
    input: DeleteItemForeverInput;
};


export type MutationDuplicateTaskListArgs = {
    input: DuplicateTaskListInput;
};


export type MutationDuplicateTaskListUnitArgs = {
    input: DuplicateTaskListUnitInput;
};


export type MutationGrantLibraryAccessArgs = {
    input: GrantLibraryAccessInput;
};


export type MutationGrantQuizAccessArgs = {
    input: GrantQuizAccessInput;
};


export type MutationGrantTaskListAccessArgs = {
    input: GrantTaskListAccessInput;
};


export type MutationGrantWorkspaceAccessArgs = {
    input: GrantWorkspaceAccessInput;
};


export type MutationManageClientUserAccessArgs = {
    input: ManageClientUserAccessInput;
};


export type MutationRegisterPushSubscriptionArgs = {
    input: RegisterPushSubscriptionInput;
};


export type MutationRemoveRoleFromUserArgs = {
    input: RemoveRoleFromUserInput;
};


export type MutationRestoreTaskArgs = {
    input: RestoreTaskInput;
};


export type MutationRestoreTaskListArgs = {
    input: RestoreTaskListInput;
};


export type MutationRestoreTaskListUnitArgs = {
    input: RestoreTaskListUnitInput;
};


export type MutationRevokeAccessArgs = {
    input: RevokeAccessInput;
};


export type MutationSaveRoleArgs = {
    input: SaveRoleInput;
};


export type MutationUnregisterPushSubscriptionArgs = {
    input: UnregisterPushSubscriptionInput;
};


export type MutationUpdateClientArgs = {
    input: UpdateClientInput;
};


export type MutationUpdateClientUserArgs = {
    input: UpdateClientUserInput;
};


export type MutationUpdateItemArgs = {
    input: UpdateItemInput;
};


export type MutationUpdateNotificationArgs = {
    input: UpdateNotificationInput;
};


export type MutationUpdateQuizArgs = {
    condition?: InputMaybe<ModelQuizConditionInput>;
    input: UpdateQuizInput;
};


export type MutationUpdateQuizAnswerArgs = {
    condition?: InputMaybe<ModelQuizAnswerConditionInput>;
    input: UpdateQuizAnswerInput;
};


export type MutationUpdateQuizQuestionArgs = {
    condition?: InputMaybe<ModelQuizQuestionConditionInput>;
    input: UpdateQuizQuestionInput;
};


export type MutationUpdateQuizStatsArgs = {
    condition?: InputMaybe<ModelQuizStatsConditionInput>;
    input: UpdateQuizStatsInput;
};


export type MutationUpdateRoleArgs = {
    input: UpdateRoleInput;
};


export type MutationUpdateTaskArgs = {
    input: UpdateTaskInput;
};


export type MutationUpdateTaskListUnitArgs = {
    input: UpdateTaskListUnitInput;
};


export type MutationUpdateTaskReportArgs = {
    input: UpdateTaskReportInput;
};


export type MutationUpdateWorkspaceArgs = {
    input: UpdateWorkspaceInput;
};


export type MutationUpdateWorkspaceUserArgs = {
    input: UpdateWorkspaceUserInput;
};

export type Notification = {
    __typename?: 'Notification';
    channelAttempts?: Maybe<Scalars['AWSJSON']['output']>;
    createdAt: Scalars['AWSDateTime']['output'];
    deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    eventId?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    initiatorId?: Maybe<Scalars['ID']['output']>;
    meta: Scalars['AWSJSON']['output'];
    ownerId: Scalars['ID']['output'];
    status?: Maybe<Scalars['String']['output']>;
    type: Scalars['String']['output'];
    updatedAt: Scalars['AWSDateTime']['output'];
    userId: Scalars['ID']['output'];
    version?: Maybe<Scalars['Int']['output']>;
};

export type NotificationUpdateResult = ConflictError | Notification;

export type Payment = {
    __typename?: 'Payment';
    billing_period?: Maybe<Scalars['AWSJSON']['output']>;
    createdAt: Scalars['AWSDateTime']['output'];
    currencyCode?: Maybe<Scalars['String']['output']>;
    gateway: Scalars['String']['output'];
    invoice_number?: Maybe<Scalars['String']['output']>;
    invoice_s3_path?: Maybe<Scalars['String']['output']>;
    ownerId: Scalars['String']['output'];
    payments?: Maybe<Scalars['String']['output']>;
    totals?: Maybe<Scalars['AWSJSON']['output']>;
    transactionId: Scalars['ID']['output'];
    transaction_items?: Maybe<Scalars['String']['output']>;
    transaction_status?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['AWSDateTime']['output'];
};

export type PaymentConnection = {
    __typename?: 'PaymentConnection';
    items: Array<Maybe<Payment>>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type PushSubscription = {
    __typename?: 'PushSubscription';
    createdAt: Scalars['AWSDateTime']['output'];
    endpoint: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    lastUsedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    userId: Scalars['ID']['output'];
};

export type PushSubscriptionKeysInput = {
    auth: Scalars['String']['input'];
    p256dh: Scalars['String']['input'];
};

export type PushSubscriptionResult = {
    __typename?: 'PushSubscriptionResult';
    success: Scalars['Boolean']['output'];
};

export type Query = {
    __typename?: 'Query';
    clientUsage: ClientUsage;
    explainAccess: AccessExplanation;
    getAuditLog: AuditLogConnection;
    getClient?: Maybe<Client>;
    getLatestQuizAnswer?: Maybe<QuizStatsResult>;
    getPushSubscriptions: Array<PushSubscription>;
    getQuiz?: Maybe<Quiz>;
    getQuizAnswer?: Maybe<QuizAnswer>;
    getQuizQuestion?: Maybe<QuizQuestion>;
    getQuizStatistics: Array<QuizStatsResult>;
    getQuizStats?: Maybe<QuizStats>;
    getQuizSummary: QuizSummary;
    getRole?: Maybe<Role>;
    getRoleBindings: RoleBindingConnection;
    getUserQuizProgress: Array<QuizProgress>;
    getUserRoles: RoleConnection;
    getUsersWithoutCompletion: Array<Scalars['ID']['output']>;
    hasReports: Scalars['Boolean']['output'];
    hybridSearch: SearchResponse;
    listClientUsers: ModelClientUserConnection;
    listItems: ModelItemConnection;
    listPayments?: Maybe<PaymentConnection>;
    listQuizAnswers?: Maybe<ModelQuizAnswerConnection>;
    listQuizByState?: Maybe<ModelQuizConnection>;
    listQuizQuestions?: Maybe<ModelQuizQuestionConnection>;
    listQuizStats?: Maybe<ModelQuizStatsConnection>;
    listQuizStatsByUser?: Maybe<ModelQuizStatsConnection>;
    listQuizzes?: Maybe<ModelQuizConnection>;
    listRoleBindings: RoleBindingConnection;
    listRolePermissions: RolePermissionConnection;
    listRoles: RoleConnection;
    listTaskListUnits: TaskListUnitConnection;
    listTasksForUnit: TaskConnection;
    listTasksReportsForUnit: TaskReportConnection;
    listUserRoles: UserRoleConnection;
    listWorkspaces: ModelWorkspaceConnection;
    notifByUser: ModelNotificationConnection;
    searchDocuments: SearchResponse;
    vectorSearch: SearchResponse;
    wsUserByUserId: ModelWorkspaceUserConnection;
    wsUserByWsId: ModelWorkspaceUserConnection;
};


export type QueryClientUsageArgs = {
    clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExplainAccessArgs = {
    input: ExplainAccessInput;
};


export type QueryGetAuditLogArgs = {
    endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
    eventType?: InputMaybe<Scalars['String']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
    userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetClientArgs = {
    id: Scalars['ID']['input'];
};


export type QueryGetLatestQuizAnswerArgs = {
    input: GetLatestQuizAnswerInput;
};


export type QueryGetQuizArgs = {
    id: Scalars['ID']['input'];
};


export type QueryGetQuizAnswerArgs = {
    id: Scalars['ID']['input'];
};


export type QueryGetQuizQuestionArgs = {
    id: Scalars['ID']['input'];
};


export type QueryGetQuizStatisticsArgs = {
    input: GetQuizStatisticsInput;
};


export type QueryGetQuizStatsArgs = {
    id: Scalars['ID']['input'];
};


export type QueryGetQuizSummaryArgs = {
    quizId: Scalars['ID']['input'];
};


export type QueryGetRoleArgs = {
    id: Scalars['ID']['input'];
};


export type QueryGetRoleBindingsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    roleId: Scalars['ID']['input'];
};


export type QueryGetUserQuizProgressArgs = {
    input: GetUserQuizProgressInput;
};


export type QueryGetUserRolesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    userId: Scalars['ID']['input'];
};


export type QueryGetUsersWithoutCompletionArgs = {
    quizId: Scalars['ID']['input'];
    workspaceId: Scalars['ID']['input'];
};


export type QueryHasReportsArgs = {
    taskId: Scalars['ID']['input'];
};


export type QueryHybridSearchArgs = {
    embedding: Array<Scalars['Float']['input']>;
    filters?: InputMaybe<SearchFilters>;
    options?: InputMaybe<SearchOptions>;
    query: Scalars['String']['input'];
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListClientUsersArgs = {
    filter?: InputMaybe<ModelClientUserFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListItemsArgs = {
    filter?: InputMaybe<ModelItemFilterInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListPaymentsArgs = {
    filter?: InputMaybe<TablePaymentFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListQuizAnswersArgs = {
    filter?: InputMaybe<ModelQuizAnswerFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    quizAndUserId: ModelStringInput;
    sortDirection?: InputMaybe<ModelSortDirection>;
    wsId: Scalars['String']['input'];
};


export type QueryListQuizByStateArgs = {
    filter?: InputMaybe<ModelQuizFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    publication_state: Scalars['String']['input'];
    wsId: Scalars['String']['input'];
};


export type QueryListQuizQuestionsArgs = {
    filter?: InputMaybe<ModelQuizQuestionFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    quizId: ModelIdInput;
    sortDirection?: InputMaybe<ModelSortDirection>;
    wsId: Scalars['String']['input'];
};


export type QueryListQuizStatsArgs = {
    filter?: InputMaybe<ModelQuizStatsFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    quizAndUserId: ModelStringInput;
    sortDirection?: InputMaybe<ModelSortDirection>;
    wsId: Scalars['String']['input'];
};


export type QueryListQuizStatsByUserArgs = {
    filter?: InputMaybe<ModelQuizStatsFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    sortDirection?: InputMaybe<ModelSortDirection>;
    userIdAndStatus: ModelStringInput;
    wsId: Scalars['String']['input'];
};


export type QueryListQuizzesArgs = {
    filter?: InputMaybe<ModelQuizFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    wsId: Scalars['String']['input'];
};


export type QueryListRoleBindingsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListRolePermissionsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListRolesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTaskListUnitsArgs = {
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    workspaceId: Scalars['ID']['input'];
};


export type QueryListTasksForUnitArgs = {
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    taskListUnitId: Scalars['ID']['input'];
    workspaceId: Scalars['ID']['input'];
};


export type QueryListTasksReportsForUnitArgs = {
    endDate?: InputMaybe<Scalars['DateTime']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    startDate?: InputMaybe<Scalars['DateTime']['input']>;
    taskListUnitId: Scalars['ID']['input'];
    workspaceId: Scalars['ID']['input'];
};


export type QueryListUserRolesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkspacesArgs = {
    filter?: InputMaybe<ModelWorkspaceFilterInput>;
    id?: InputMaybe<Scalars['ID']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryNotifByUserArgs = {
    filter?: InputMaybe<ModelNotificationFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    ownerId: Scalars['ID']['input'];
    sortDirection?: InputMaybe<ModelSortDirection>;
    userIdCreatedAt?: InputMaybe<ModelNotificationByClientCompositeKeyConditionInput>;
};


export type QuerySearchDocumentsArgs = {
    filters?: InputMaybe<SearchFilters>;
    options?: InputMaybe<SearchOptions>;
    query: Scalars['String']['input'];
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVectorSearchArgs = {
    embedding: Array<Scalars['Float']['input']>;
    filters?: InputMaybe<SearchFilters>;
    options?: InputMaybe<SearchOptions>;
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryWsUserByUserIdArgs = {
    filter?: InputMaybe<ModelWorkspaceUserFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    ownerId: Scalars['ID']['input'];
    sortDirection?: InputMaybe<ModelSortDirection>;
    userId?: InputMaybe<ModelIdKeyConditionInput>;
};


export type QueryWsUserByWsIdArgs = {
    filter?: InputMaybe<ModelWorkspaceUserFilterInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    nextToken?: InputMaybe<Scalars['String']['input']>;
    ownerId: Scalars['ID']['input'];
    sortDirection?: InputMaybe<ModelSortDirection>;
    workspaceIdUserId?: InputMaybe<ModelWorkspaceUserByWorkspaceCompositeKeyConditionInput>;
};

export type Quiz = {
    __typename?: 'Quiz';
    createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
    creator: Scalars['String']['output'];
    description?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    latestEditor?: Maybe<Scalars['String']['output']>;
    meta?: Maybe<Scalars['AWSJSON']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    ownerIdAndWsId: Scalars['String']['output'];
    publication_state?: Maybe<Scalars['String']['output']>;
    questionsCount?: Maybe<Scalars['Int']['output']>;
    questionsOrder?: Maybe<Scalars['AWSJSON']['output']>;
    relatedPages?: Maybe<Scalars['String']['output']>;
    requiredPassPercentage?: Maybe<Scalars['Int']['output']>;
    stats?: Maybe<Scalars['AWSJSON']['output']>;
    updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    version: Scalars['Int']['output'];
};

export type QuizAnswer = {
    __typename?: 'QuizAnswer';
    answers?: Maybe<Scalars['AWSJSON']['output']>;
    attempt?: Maybe<Scalars['Int']['output']>;
    completedAt: Scalars['AWSDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    ownerIdAndWsId: Scalars['String']['output'];
    quizAndUserId: Scalars['String']['output'];
    quizId: Scalars['ID']['output'];
    score?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    userId: Scalars['String']['output'];
};

export type QuizAnswerUpdateResult = ConflictError | QuizAnswer;

export type QuizProgress = {
    __typename?: 'QuizProgress';
    latestAttempt?: Maybe<QuizStatsResult>;
    quizId: Scalars['ID']['output'];
    quizName?: Maybe<Scalars['String']['output']>;
    totalAttempts: Scalars['Int']['output'];
};

export type QuizQuestion = {
    __typename?: 'QuizQuestion';
    id: Scalars['ID']['output'];
    options?: Maybe<Scalars['AWSJSON']['output']>;
    ownerIdAndWsId: Scalars['String']['output'];
    quizId: Scalars['ID']['output'];
    text: Scalars['String']['output'];
    version: Scalars['Int']['output'];
};

export type QuizQuestionUpdateResult = ConflictError | QuizQuestion;

export type QuizStats = {
    __typename?: 'QuizStats';
    answerId: Scalars['String']['output'];
    attempt?: Maybe<Scalars['Int']['output']>;
    completePercentage?: Maybe<Scalars['String']['output']>;
    completedAt: Scalars['AWSDateTime']['output'];
    id: Scalars['ID']['output'];
    ownerIdAndWsId: Scalars['String']['output'];
    quizAndUserId: Scalars['ID']['output'];
    quizId: Scalars['ID']['output'];
    score?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    userId: Scalars['String']['output'];
    userIdAndStatus?: Maybe<Scalars['String']['output']>;
};

export type QuizStatsResult = {
    __typename?: 'QuizStatsResult';
    answerId: Scalars['ID']['output'];
    attempt: Scalars['Int']['output'];
    completePercentage: Scalars['String']['output'];
    completedAt: Scalars['AWSDateTime']['output'];
    id: Scalars['ID']['output'];
    ownerId: Scalars['ID']['output'];
    quizId: Scalars['ID']['output'];
    score: Scalars['String']['output'];
    status: Scalars['String']['output'];
    userId: Scalars['ID']['output'];
    workspaceId: Scalars['ID']['output'];
};

export type QuizStatsUpdateResult = ConflictError | QuizStats;

export type QuizSummary = {
    __typename?: 'QuizSummary';
    averageScore: Scalars['Float']['output'];
    failedCount: Scalars['Int']['output'];
    passRate: Scalars['Float']['output'];
    passedCount: Scalars['Int']['output'];
    totalAttempts: Scalars['Int']['output'];
    uniqueUsers: Scalars['Int']['output'];
};

export type QuizUpdateResult = ConflictError | Quiz;

export type RegisterPushSubscriptionInput = {
    endpoint: Scalars['String']['input'];
    keys: PushSubscriptionKeysInput;
    userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveRoleFromUserInput = {
    roleId: Scalars['ID']['input'];
    userId: Scalars['ID']['input'];
};

export type RestoreTaskInput = {
    id: Scalars['ID']['input'];
};

export type RestoreTaskListInput = {
    taskListId: Scalars['ID']['input'];
    taskListUnitId: Scalars['ID']['input'];
};

export type RestoreTaskListUnitInput = {
    id: Scalars['ID']['input'];
};

export type RevokeAccessInput = {
    bindingId: Scalars['ID']['input'];
};


export interface IncludeFutureItem {
    tests: boolean;
    libraries: boolean;
    locations: boolean;
}

export type IncludeFutureConfig = Record<string, IncludeFutureItem>;

export type Role = {
    __typename?: 'Role';
    createdAt: Scalars['AWSDateTime']['output'];
    createdBy?: Maybe<Scalars['ID']['output']>;
    description?: Scalars['String']['output'];
    displayName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    includeFutureConfig?: IncludeFutureConfig;
    key: Scalars['String']['output'];
    ownerId: Scalars['ID']['output'];
    updatedAt: Scalars['AWSDateTime']['output'];
    updatedBy?: Maybe<Scalars['ID']['output']>;
    workspaceId: Scalars['ID']['output'];
};

export type RoleBinding = {
    __typename?: 'RoleBinding';
    createdAt: Scalars['AWSDateTime']['output'];
    createdBy?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    objectId?: Maybe<Scalars['ID']['output']>;
    objectType: RoleBindingObjectType;
    ownerId: Scalars['ID']['output'];
    roleId: Scalars['ID']['output'];
    subjectId: Scalars['ID']['output'];
    workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type RoleBindingConnection = {
    __typename?: 'RoleBindingConnection';
    items: Array<RoleBinding>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export enum RoleBindingObjectType {
    Item = 'item',
    Quiz = 'quiz',
    TaskList = 'task_list',
    TaskListUnit = 'task_list_unit',
    Workspace = 'workspace'
}

export type RoleConnection = {
    __typename?: 'RoleConnection';
    items: Array<Role>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type RolePermission = {
    __typename?: 'RolePermission';
    createdAt: Scalars['AWSDateTime']['output'];
    createdBy?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    objectId?: Maybe<Scalars['ID']['output']>;
    objectType: RoleBindingObjectType;
    ownerId: Scalars['ID']['output'];
    roleId: Scalars['ID']['output'];
    workspaceId: Scalars['ID']['output'];
};

export type RolePermissionConnection = {
    __typename?: 'RolePermissionConnection';
    items: Array<RolePermission>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type SaveRoleInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    includeFutureLibraries?: InputMaybe<Scalars['Boolean']['input']>;
    includeFutureLocations?: InputMaybe<Scalars['Boolean']['input']>;
    includeFutureTests?: InputMaybe<Scalars['Boolean']['input']>;
    libraries: Array<EntitySelectionInput>;
    locations: Array<EntitySelectionInput>;
    memberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    name: Scalars['String']['input'];
    roleId?: InputMaybe<Scalars['ID']['input']>;
    tests: Array<EntitySelectionInput>;
    workspaceIds: Array<Scalars['ID']['input']>;
};

export type SearchFilters = {
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    docType?: InputMaybe<Scalars['String']['input']>;
    trashed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchOptions = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    textWeight?: InputMaybe<Scalars['Float']['input']>;
    vectorWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchResponse = {
    __typename?: 'SearchResponse';
    items: Array<SearchResult>;
    totalCount: Scalars['Int']['output'];
};

export type SearchResult = {
    __typename?: 'SearchResult';
    id: Scalars['ID']['output'];
    itemId: Scalars['ID']['output'];
    score: Scalars['Float']['output'];
    similarity?: Maybe<Scalars['Float']['output']>;
    snippet?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    workspaceId: Scalars['ID']['output'];
};

export type SearchStats = {
    __typename?: 'SearchStats';
    averageContentLength: Scalars['Float']['output'];
    documentsWithEmbeddings: Scalars['Int']['output'];
    totalDocuments: Scalars['Int']['output'];
};

export type Subscription = {
    __typename?: 'Subscription';
    onClientUsageUpdated: ClientUsage;
    onCreateClientUser: ClientUser;
    onCreateItem: Item;
    onCreateNotification: Notification;
    onCreateQuiz?: Maybe<Quiz>;
    onCreateQuizAnswer?: Maybe<QuizAnswer>;
    onCreateQuizQuestion?: Maybe<QuizQuestion>;
    onCreateQuizStats?: Maybe<QuizStats>;
    onCreateRole: Role;
    onCreateRoleBinding: RoleBinding;
    onCreateRolePermission: RolePermission;
    onCreateTask: Task;
    onCreateTaskListUnit: TaskListUnit;
    onCreateTaskReport: TaskReport;
    onCreateUserRole: UserRole;
    onCreateWorkspace: Workspace;
    onCreateWorkspaceUser: WorkspaceUser;
    onDeleteClientUser: ClientUser;
    onDeleteItem: Item;
    onDeleteNotification: Notification;
    onDeleteQuiz?: Maybe<Quiz>;
    onDeleteQuizAnswer?: Maybe<QuizAnswer>;
    onDeleteQuizQuestion?: Maybe<QuizQuestion>;
    onDeleteQuizStats?: Maybe<QuizStats>;
    onDeleteRole: Role;
    onDeleteRoleBinding: RoleBinding;
    onDeleteRolePermission: RolePermission;
    onDeleteTask: Task;
    onDeleteTaskListUnit: TaskListUnit;
    onDeleteTaskReport: TaskReport;
    onDeleteUserRole: UserRole;
    onDeleteWorkspace: Workspace;
    onDeleteWorkspaceUser: WorkspaceUser;
    onUpdateClient: Client;
    onUpdateClientUser: ClientUser;
    onUpdateItem: Item;
    onUpdateNotification: Notification;
    onUpdateQuiz?: Maybe<Quiz>;
    onUpdateQuizAnswer?: Maybe<QuizAnswer>;
    onUpdateQuizQuestion?: Maybe<QuizQuestion>;
    onUpdateQuizStats?: Maybe<QuizStats>;
    onUpdateRole: Role;
    onUpdateRoleBinding: RoleBinding;
    onUpdateRolePermission: RolePermission;
    onUpdateTask: Task;
    onUpdateTaskListUnit: TaskListUnit;
    onUpdateTaskReport: TaskReport;
    onUpdateUserRole: UserRole;
    onUpdateWorkspace: Workspace;
    onUpdateWorkspaceUser: WorkspaceUser;
};


export type SubscriptionOnClientUsageUpdatedArgs = {
    clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnCreateClientUserArgs = {
    filter?: InputMaybe<ModelSubscriptionClientUserFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateItemArgs = {
    filter?: InputMaybe<ModelSubscriptionItemFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateNotificationArgs = {
    filter?: InputMaybe<ModelSubscriptionNotificationFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateQuizArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateQuizAnswerArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizAnswerFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateQuizQuestionArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizQuestionFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateQuizStatsArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizStatsFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateRoleArgs = {
    filter?: InputMaybe<ModelSubscriptionRoleFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateRoleBindingArgs = {
    filter?: InputMaybe<ModelSubscriptionRoleBindingFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateRolePermissionArgs = {
    filter?: InputMaybe<ModelSubscriptionRolePermissionFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateTaskArgs = {
    taskListUnitId: ModelSubscriptionIdInput;
};


export type SubscriptionOnCreateTaskListUnitArgs = {
    workspaceId: ModelSubscriptionIdInput;
};


export type SubscriptionOnCreateTaskReportArgs = {
    taskListUnitId: ModelSubscriptionIdInput;
};


export type SubscriptionOnCreateUserRoleArgs = {
    filter?: InputMaybe<ModelSubscriptionUserRoleFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateWorkspaceArgs = {
    filter?: InputMaybe<ModelSubscriptionWorkspaceFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateWorkspaceUserArgs = {
    filter?: InputMaybe<ModelSubscriptionWorkspaceUserFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteClientUserArgs = {
    filter?: InputMaybe<ModelSubscriptionClientUserFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteItemArgs = {
    filter?: InputMaybe<ModelSubscriptionItemFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteNotificationArgs = {
    filter?: InputMaybe<ModelSubscriptionNotificationFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteQuizArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteQuizAnswerArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizAnswerFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteQuizQuestionArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizQuestionFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteQuizStatsArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizStatsFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteRoleArgs = {
    filter?: InputMaybe<ModelSubscriptionRoleFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteRoleBindingArgs = {
    filter?: InputMaybe<ModelSubscriptionRoleBindingFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteRolePermissionArgs = {
    filter?: InputMaybe<ModelSubscriptionRolePermissionFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteTaskArgs = {
    taskListUnitId: ModelSubscriptionIdInput;
};


export type SubscriptionOnDeleteTaskListUnitArgs = {
    workspaceId: ModelSubscriptionIdInput;
};


export type SubscriptionOnDeleteTaskReportArgs = {
    taskListUnitId: ModelSubscriptionIdInput;
};


export type SubscriptionOnDeleteUserRoleArgs = {
    filter?: InputMaybe<ModelSubscriptionUserRoleFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteWorkspaceArgs = {
    filter?: InputMaybe<ModelSubscriptionWorkspaceFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteWorkspaceUserArgs = {
    filter?: InputMaybe<ModelSubscriptionWorkspaceUserFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateClientArgs = {
    filter?: InputMaybe<ModelSubscriptionClientFilterInput>;
    id?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateClientUserArgs = {
    filter?: InputMaybe<ModelSubscriptionClientUserFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateItemArgs = {
    filter?: InputMaybe<ModelSubscriptionItemFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateNotificationArgs = {
    filter?: InputMaybe<ModelSubscriptionNotificationFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateQuizArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateQuizAnswerArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizAnswerFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateQuizQuestionArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizQuestionFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateQuizStatsArgs = {
    filter?: InputMaybe<ModelSubscriptionQuizStatsFilterInput>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateRoleArgs = {
    filter?: InputMaybe<ModelSubscriptionRoleFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateRoleBindingArgs = {
    filter?: InputMaybe<ModelSubscriptionRoleBindingFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateRolePermissionArgs = {
    filter?: InputMaybe<ModelSubscriptionRolePermissionFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateTaskArgs = {
    taskListUnitId: ModelSubscriptionIdInput;
};


export type SubscriptionOnUpdateTaskListUnitArgs = {
    workspaceId: ModelSubscriptionIdInput;
};


export type SubscriptionOnUpdateTaskReportArgs = {
    taskListUnitId: ModelSubscriptionIdInput;
};


export type SubscriptionOnUpdateUserRoleArgs = {
    filter?: InputMaybe<ModelSubscriptionUserRoleFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateWorkspaceArgs = {
    filter?: InputMaybe<ModelSubscriptionWorkspaceFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateWorkspaceUserArgs = {
    filter?: InputMaybe<ModelSubscriptionWorkspaceUserFilterInput>;
    ownerId?: InputMaybe<Scalars['String']['input']>;
};

export type TablePaymentFilterInput = {
    date?: InputMaybe<TableStringFilterInput>;
    status?: InputMaybe<TableStringFilterInput>;
};

export type TableStringFilterInput = {
    beginsWith?: InputMaybe<Scalars['String']['input']>;
    between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    contains?: InputMaybe<Scalars['String']['input']>;
    eq?: InputMaybe<Scalars['String']['input']>;
    ge?: InputMaybe<Scalars['String']['input']>;
    gt?: InputMaybe<Scalars['String']['input']>;
    le?: InputMaybe<Scalars['String']['input']>;
    lt?: InputMaybe<Scalars['String']['input']>;
    notContains?: InputMaybe<Scalars['String']['input']>;
};

export type Task = {
    __typename?: 'Task';
    config?: Maybe<Scalars['JSON']['output']>;
    createdAt: string;
    createdBy: string;
    description?: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    images?: Maybe<TaskReportFileMeta[]>;
    isArchived: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    relatedPage?: Maybe<Scalars['ID']['output']>;
    scheduleRule?: Maybe<Scalars['JSON']['output']>;
    taskListId?: Maybe<Scalars['ID']['output']>;
    taskListUnitId: Scalars['ID']['output'];
    updatedAt: string;
    updatedBy: string;
    version: Scalars['Int']['output'];
};

export type TaskConnection = {
    __typename?: 'TaskConnection';
    items: Array<Task>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type TaskListUnit = {
    __typename?: 'TaskListUnit';
    avatarPath?: Maybe<Scalars['String']['output']>;
    createdAt: string;
    createdBy?: Maybe<Scalars['ID']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isArchived: Scalars['Boolean']['output'];
    logicalDayShift: Scalars['Int']['output'];
    name: Scalars['String']['output'];
    ownerId: Scalars['ID']['output'];
    taskLists: Scalars['JSON']['output'];
    taskListsOrder: Array<Scalars['ID']['output']>;
    timezone: Scalars['String']['output'];
    updatedAt: string;
    updatedBy?: Maybe<Scalars['ID']['output']>;
    version: Scalars['Int']['output'];
    workspaceId: Scalars['ID']['output'];
};

export type TaskListUnitConnection = {
    __typename?: 'TaskListUnitConnection';
    items: Array<TaskListUnit>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type TaskListUnitUpdateResult = ConflictError | TaskListUnit;

export type TaskReport = {
    __typename?: 'TaskReport';
    comment?: Maybe<Scalars['String']['output']>;
    commentImages?: Maybe<TaskReportFileMeta[]>;
    completedBy?: Maybe<Array<Scalars['ID']['output']>>;
    createdAt: string;
    createdBy: string;
    completedAt: string;
    status: TaskReportStatus;
    id: Scalars['ID']['output'];
    images?: Maybe<TaskReportFileMeta[]>;
    logicalDayStart?: Maybe<Scalars['DateTime']['output']>;
    taskId: Scalars['ID']['output'];
    taskListUnitId: Scalars['ID']['output'];
    updatedAt: string;
    updatedBy: string;
    version: Scalars['Int']['output'];
};

export type TaskReportConnection = {
    __typename?: 'TaskReportConnection';
    items: Array<TaskReport>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export enum TaskReportStatus {
    Completed = 'completed',
    Incomplete = 'incomplete',
    Skipped = 'skipped'
}

export type TaskReportUpdateResult = ConflictError | TaskReport;

export type TaskUpdateResult = ConflictError | Task;

export type UnregisterPushSubscriptionInput = {
    endpoint: Scalars['String']['input'];
};

export type UpdateClientInput = {
    created_at?: InputMaybe<Scalars['String']['input']>;
    customer_id?: InputMaybe<Scalars['String']['input']>;
    defaultWorkspaces?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    inviteLink?: InputMaybe<Scalars['String']['input']>;
    meta?: InputMaybe<Scalars['AWSJSON']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerUserId?: InputMaybe<Scalars['ID']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    subscription_details?: InputMaybe<Scalars['AWSJSON']['input']>;
    subscription_endsAt?: InputMaybe<Scalars['String']['input']>;
    subscription_plan?: InputMaybe<Scalars['String']['input']>;
    subscription_status?: InputMaybe<Scalars['String']['input']>;
    userRole?: InputMaybe<Scalars['String']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClientUserInput = {
    avatarPath?: InputMaybe<Scalars['String']['input']>;
    closedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
    isConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
    isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
    lastActive?: InputMaybe<Scalars['AWSDateTime']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerId?: InputMaybe<Scalars['ID']['input']>;
    roleUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    roles?: InputMaybe<Scalars['AWSJSON']['input']>;
    sub?: InputMaybe<Scalars['String']['input']>;
    surname?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateItemInput = {
    ackUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    acknowledgement?: InputMaybe<Scalars['AWSJSON']['input']>;
    acknowledgementRequired?: InputMaybe<Scalars['Boolean']['input']>;
    archived?: InputMaybe<Scalars['Boolean']['input']>;
    childIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    creator?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    ownerId?: InputMaybe<Scalars['ID']['input']>;
    parentIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    pinned?: InputMaybe<Scalars['Boolean']['input']>;
    pinnedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    readRoles?: InputMaybe<Scalars['AWSJSON']['input']>;
    statusRestoreParentIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    statusSourceLibraryId?: InputMaybe<Scalars['ID']['input']>;
    statusUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    trashed?: InputMaybe<Scalars['Boolean']['input']>;
    type?: InputMaybe<ItemType>;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
    writeRoles?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateNotificationInput = {
    channelAttempts?: InputMaybe<Scalars['AWSJSON']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    eventId?: InputMaybe<Scalars['ID']['input']>;
    id: Scalars['ID']['input'];
    initiatorId?: InputMaybe<Scalars['ID']['input']>;
    meta?: InputMaybe<Scalars['AWSJSON']['input']>;
    ownerId?: InputMaybe<Scalars['ID']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateQuizAnswerInput = {
    answers?: InputMaybe<Scalars['AWSJSON']['input']>;
    attempt?: InputMaybe<Scalars['Int']['input']>;
    completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    duration?: InputMaybe<Scalars['Int']['input']>;
    id: Scalars['ID']['input'];
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
    quizAndUserId?: InputMaybe<Scalars['String']['input']>;
    quizId?: InputMaybe<Scalars['ID']['input']>;
    score?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    version: Scalars['Int']['input'];
};

export type UpdateQuizInput = {
    creator?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    latestEditor?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
    publication_state?: InputMaybe<Scalars['String']['input']>;
    questionsCount?: InputMaybe<Scalars['Int']['input']>;
    questionsOrder?: InputMaybe<Scalars['AWSJSON']['input']>;
    relatedPages?: InputMaybe<Scalars['String']['input']>;
    requiredPassPercentage?: InputMaybe<Scalars['Int']['input']>;
    statsPartId?: InputMaybe<Scalars['String']['input']>;
    statsPartValue?: InputMaybe<Scalars['AWSJSON']['input']>;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    version: Scalars['Int']['input'];
};

export type UpdateQuizQuestionInput = {
    id: Scalars['ID']['input'];
    options?: InputMaybe<Scalars['AWSJSON']['input']>;
    ownerIdAndWsId?: InputMaybe<Scalars['String']['input']>;
    quizId?: InputMaybe<Scalars['ID']['input']>;
    text?: InputMaybe<Scalars['String']['input']>;
    version: Scalars['Int']['input'];
};

export type UpdateQuizStatsInput = {
    answerId?: InputMaybe<Scalars['String']['input']>;
    attempt?: InputMaybe<Scalars['Int']['input']>;
    completePercentage?: InputMaybe<Scalars['String']['input']>;
    completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    ownerIdAndWsId: Scalars['String']['input'];
    quizAndUserId: Scalars['ID']['input'];
    quizId?: InputMaybe<Scalars['ID']['input']>;
    score?: InputMaybe<Scalars['String']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['String']['input']>;
    userIdAndStatus?: InputMaybe<Scalars['String']['input']>;
    version: Scalars['Int']['input'];
};

export type UpdateRoleInput = {
    description?: InputMaybe<Scalars['String']['input']>;
    displayName?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
};

export type UpdateTaskInput = {
    config?: InputMaybe<Scalars['JSON']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    images?: InputMaybe<Scalars['JSON']['input']>;
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    relatedPage?: InputMaybe<Scalars['ID']['input']>;
    scheduleRule?: InputMaybe<Scalars['JSON']['input']>;
    taskListId?: InputMaybe<Scalars['ID']['input']>;
    taskListUnitId?: InputMaybe<Scalars['ID']['input']>;
    version: Scalars['Int']['input'];
};

export type UpdateTaskListUnitInput = {
    avatarPath?: InputMaybe<Scalars['String']['input']>;
    description?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    logicalDayShift?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    taskLists?: InputMaybe<Scalars['JSON']['input']>;
    taskListsOrder?: InputMaybe<Array<Scalars['ID']['input']>>;
    timezone?: InputMaybe<Scalars['String']['input']>;
    version: Scalars['Int']['input'];
};

export type UpdateTaskReportInput = {
    comment?: InputMaybe<Scalars['String']['input']>;
    commentImages?: InputMaybe<Scalars['JSON']['input']>;
    completedAt?: InputMaybe<Scalars['DateTime']['input']>;
    completedBy?: InputMaybe<Array<Scalars['ID']['input']>>;
    id: Scalars['ID']['input'];
    images?: InputMaybe<Scalars['JSON']['input']>;
    status?: InputMaybe<TaskReportStatus>;
    version: Scalars['Int']['input'];
};

export type UpdateWorkspaceInput = {
    archivedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    avatarPath?: InputMaybe<Scalars['String']['input']>;
    childIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    id: Scalars['ID']['input'];
    name?: InputMaybe<Scalars['String']['input']>;
    ownerId?: InputMaybe<Scalars['ID']['input']>;
    pinnedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    slug?: InputMaybe<Scalars['String']['input']>;
    trashedIds?: InputMaybe<Scalars['AWSJSON']['input']>;
    updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWorkspaceUserInput = {
    createdBy?: InputMaybe<Scalars['String']['input']>;
    id: Scalars['ID']['input'];
    ownerId?: InputMaybe<Scalars['ID']['input']>;
    role?: InputMaybe<Scalars['String']['input']>;
    updatedBy?: InputMaybe<Scalars['String']['input']>;
    userId?: InputMaybe<Scalars['ID']['input']>;
    version?: InputMaybe<Scalars['Int']['input']>;
    workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserRole = {
    __typename?: 'UserRole';
    createdAt: Scalars['AWSDateTime']['output'];
    createdBy?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    ownerId: Scalars['ID']['output'];
    roleId: Scalars['ID']['output'];
    userId: Scalars['ID']['output'];
    workspaceId: Scalars['ID']['output'];
};

export type UserRoleConnection = {
    __typename?: 'UserRoleConnection';
    items: Array<UserRole>;
    nextToken?: Maybe<Scalars['String']['output']>;
};

export type Workspace = {
    __typename?: 'Workspace';
    archivedIds: Scalars['AWSJSON']['output'];
    avatarPath?: Maybe<Scalars['String']['output']>;
    childIds: Scalars['AWSJSON']['output'];
    createdAt: Scalars['AWSDateTime']['output'];
    deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    ownerId: Scalars['ID']['output'];
    pinnedIds?: Maybe<Scalars['AWSJSON']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    trashedIds: Scalars['AWSJSON']['output'];
    updatedAt: Scalars['AWSDateTime']['output'];
    version: Scalars['Int']['output'];
};

export type WorkspaceUpdateResult = ConflictError | Workspace;

export type WorkspaceUser = {
    __typename?: 'WorkspaceUser';
    createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    id: Scalars['ID']['output'];
    ownerId: Scalars['ID']['output'];
    role: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
    userId: Scalars['ID']['output'];
    version: Scalars['Int']['output'];
    workspaceId: Scalars['ID']['output'];
};

export type TaskList = {
    __typename?: 'TaskList';
    childIds: Array<Scalars['String']['output']>;
    createdAt: string;
    createdBy: string;
    description?: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    isArchived: Scalars['Boolean']['output'];
    name: Scalars['String']['output'];
    updatedAt: string;
    updatedBy: string;
    isDisabled?: boolean; // for auto created group
    deletedAt?: string;
}
